import React, { useEffect, useState } from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import { Typography, TextField, Box } from '@material-ui/core';
import styles from './DialogBox.style';
import moment from 'moment';
import RBButton from '../Shared/RBButton';
import ErrorIcon from '@material-ui/icons/Error';
import { DRAFT_NAME_EXISTS, BAD_CHARACTER_SET, INVALID_DRAFT_NAME } from 'constants/constant';
import { colors } from 'theme/color-palette';
import { useSelector } from 'react-redux';

const { ERROR } = colors;

function PreviewDialog({
	open,
	onPrimaryClick,
	onSecondaryClick,
	title,
	bodyContent,
	secondaryBtnText,
	primaryBtnText,
	hideTitle = false,
	hidePrimaryBtn = false,
	hideSecondaryBtn = false,
	showTextBox = false,
	hideBodyContent,
	defaultTxtValue,
	dialogWidth
}) {
	const classes = styles();

	const [textValue, setTextValue] = useState();
	const [error, showError] = useState(false);
	const [errorName, setErrorName] = useState();
	const [existingDraftNames, setExistingDraftNames] = useState([]);
	const savedReportsList = useSelector((state) => state.dashboardReducer.savedReportsList);

	useEffect(() => {
		const today = new Date();
		if (defaultTxtValue === undefined) {
			setTextValue(`Report-${moment.utc(today).local().format('HHmmAYYYYMMDD')}`);
		} else {
			setTextValue(defaultTxtValue.trim());
		}

		/** if textfield is visible, then only process below statement */
		if (showTextBox) {
			const names = savedReportsList.map((el) => el.draftName);
			setExistingDraftNames(names);
		}
	}, []);

	const handlePrimary = (e) => {
		if (error) {
			return;
		}
		if (showTextBox) {
			onPrimaryClick(textValue.trim(), e);
		} else {
			onPrimaryClick(e);
		}
	};

	const handleSecondary = (e) => {
		onSecondaryClick(e);
	};

	const DTitle = () => {
		if (hideTitle) {
			return null;
		}
		return (
			<DialogTitle className={classes.tittlePadding}>
				<Typography className={classes.dialogTitle}>{title}</Typography>
			</DialogTitle>
		);
	};

	const DBodyContent = () => {
		if (hideBodyContent) {
			return null;
		}
		return (
			<DialogContent className={classes.contentPadding}>
				<Typography className={classes.dialogContent}>{bodyContent}</Typography>
			</DialogContent>
		);
	};

	const SecondaryButton = () => {
		if (hidePrimaryBtn) {
			return null;
		}
		return (
			<RBButton
				id="preview-dialog-secondary"
				cbHandleClick={(e) => handleSecondary(e)}
				btnName={secondaryBtnText}
				type="secondary"
				style={{ width: 'fit-content', minWidth: 135 }}
			/>
		);
	};

	const handleChange = (e) => {
		const value = e.target.value;
		if (PreviewDialog.matcher.test(value.trim())) {
			showError(true);
			setErrorName(BAD_CHARACTER_SET);
		} else if (existingDraftNames.includes(value.trim())) {
			showError(true);
			setErrorName(DRAFT_NAME_EXISTS);
		} else if (value === '') {
			showError(true);
			setErrorName(INVALID_DRAFT_NAME);
		} else {
			showError(false);
		}
		setTextValue(value);
	};

	return (
		<Dialog
			id="preview-dialog"
			aria-labelledby="confirmation-dialog-title"
			open={open}
			className={classes.container}
			classes={
				dialogWidth
					? {
							paperWidthSm: dialogWidth
					  }
					: {}
			}
			onClick={(e) => {
				e.stopPropagation();
			}}>
			<Box className={classes.content}>
				<DTitle />
				<DBodyContent />
				{showTextBox && (
					<TextField
						id="draft-name"
						color="primary"
						value={textValue}
						style={{ margin: '16px', minWidth: 400 }}
						onChange={handleChange}
						variant="outlined"
						helperText={
							error ? (
								<>
									{errorName === BAD_CHARACTER_SET ? (
										<ErrorIcon style={{ color: ERROR, paddingRight: '10px' }} />
									) : null}
									<Typography component={'span'} fontSize="14px">
										{error && errorName}
									</Typography>
								</>
							) : null
						}
						FormHelperTextProps={{ classes: { root: classes.reportNameError } }}
						maxLength={50}
						focused
						onKeyUp={(e) => {
							e.stopPropagation();
							if (e.key === 'Enter') {
								if (defaultTxtValue === textValue) return;
								handlePrimary(e);
							}
						}}
					/>
				)}
				<DialogActions className={`${classes.actionBtnPadding}`}>
					<SecondaryButton />
					{!hideSecondaryBtn && (
						<RBButton
							id="preview-dialog-primary"
							cbHandleClick={(e) => handlePrimary(e)}
							btnName={primaryBtnText}
							type="primary"
							style={{ width: 'fit-content', minWidth: 135 }}
							disabled={defaultTxtValue === textValue}
						/>
					)}
				</DialogActions>
			</Box>
		</Dialog>
	);
}

PreviewDialog.matcher = new RegExp('[&*,<>\\[\\]/\\\\"\']');

export default PreviewDialog;
